import "./index27.mjs";
import "./index28.mjs";
import "./index29.mjs";
import "./index30.mjs";
import "./index31.mjs";
import "./index32.mjs";
import "./index33.mjs";
import "./index34.mjs";
import "./index35.mjs";
import "./index36.mjs";
import { v4 as O } from "uuid";
import "./index37.mjs";
import "./index38.mjs";
import "./index39.mjs";
import "./index40.mjs";
import "./index41.mjs";
import "./index42.mjs";
var p = "https://js.verygoodvault.com", m = "https://js3.verygoodvault.com", y = "https://vgs-collect-keeper.apps.verygood.systems", h = /* @__PURE__ */ O(), l = {
  vaultId: "",
  environment: "sandbox",
  version: "canary"
}, s = {
  // Script loaded from npm module
  LOADED_FROM_PACKAGE: "LoadedFromPackage",
  // Script loaded
  SCRIPT_LOAD: "ScriptLoad",
  // VGSCollect instance is undefined
  INSTANCE_UNDEFINED: "InstanceUndefined"
}, v = {
  IS_REQUIRED: function(n) {
    return n + " is required.";
  },
  IS_UNDEFINED: function(n) {
    return n + " is undefined.";
  },
  IS_INVALID: function(n) {
    return n + " is invalid.";
  },
  UNABLE_TO_FIND: function(n) {
    return "Unable to find " + n;
  },
  SCRIPT_WAS_NOT_LOADED: "VGS Collect.js script was not loaded.",
  CHANGE_VERSION: "Please explicitly set locked VGS Collect.js version before going live. Check out the changelog https://www.verygoodsecurity.com/docs/vgs-collect/js/changelog"
}, N = l, V = function(n) {
  n && (N = Object.assign({}, n));
}, I = function() {
  return N;
}, G = {
  vaultId: function(n) {
    return typeof n == "string" && /^tnt.{8}$/.test(n);
  },
  environment: function(n) {
    return typeof n == "string" && /^(sandbox|live)((-eu)-\d{1})?$/.test(n);
  },
  version: function(n) {
    return n === "canary" || typeof n == "string" && /^\d{1,2}\.\d{1,2}(\.\d{1,2})?$/.test(n) && !n.startsWith("1.");
  }
}, _ = function(n) {
  throw new Error(v.IS_REQUIRED(n));
}, L = function(n, r) {
  if (n) {
    var t = Object.keys(n).filter(function(i) {
      return !n[i](r[i]);
    }).map(function(i) {
      return new Error(v.IS_INVALID(i));
    });
    if (t.length) {
      var o = t[0];
      throw o;
    }
  }
}, R = function(n) {
  L(G, n);
}, P = function(n) {
  R(n), V(n), u({
    type: s.LOADED_FROM_PACKAGE
  });
}, u = function(n) {
  var r = I(), t = r.vaultId, o = r.environment, i = r.version, a = "", c = {
    env: o,
    tnt: t,
    userAgent: window.navigator.userAgent,
    version: i,
    timestamp: Date.now(),
    vgsCollectSessionId: h
  };
  try {
    a = window.btoa(JSON.stringify(Object.assign({}, n, c)));
  } catch {
    return;
  }
  fetch(y + "/vgs", {
    method: "POST",
    body: a
  }).then(function() {
    return !0;
  }).catch(function() {
    return !0;
  });
}, A = function(n) {
  var r = document.head || document.body;
  if (!r)
    throw new Error(v.UNABLE_TO_FIND("document.head or document.body"));
  return r.appendChild(n), n;
}, d = function(n, r) {
  var t = document.createElement("link");
  t.rel = n, t.href = r, A(t);
}, C = function(n) {
  var r = n.split("."), t = parseInt(r[0]) || 0, o = parseInt(r[1]) || 0, i = parseInt(r[2]) || 0;
  return {
    major: t,
    minor: o,
    patch: i
  };
}, T = function(n, r) {
  if (n === "canary")
    return !0;
  var t = C(n), o = C(r);
  return t.major !== o.major ? t.major > o.major : t.minor !== o.minor ? t.minor > o.minor : t.patch !== o.patch ? t.patch > o.patch : !1;
}, S = p, F = function() {
  try {
    var n = document.querySelectorAll('script[src^="' + S + '/vgs-collect/"]');
    return n.length > 0;
  } catch {
    return !1;
  }
}, U = function() {
  var n = I(), r = n.vaultId, t = n.environment, o = n.version, i = document.createElement("script");
  return i.src = S + "/vgs-collect/" + o + "/vgs-collect.js?sessionId=" + h + "&tenantId=" + r + "&env=" + t, A(i), i;
}, j = function e(n) {
  n === void 0 && (n = !0);
  var r = new Promise(function(t, o) {
    var i = I(), a = i.version;
    if (F() && window.VGSCollect && t(window.VGSCollect), !n && T(a, "2.3.0") && (S = m), !window.VGSCollect) {
      var c = U();
      c && (c.onload = function() {
        window.VGSCollect || (u({
          type: s.INSTANCE_UNDEFINED,
          status: "OK",
          mainCDN: n
        }), o(v.IS_UNDEFINED("VGS Collect"))), u({
          type: s.SCRIPT_LOAD,
          status: "OK",
          mainCDN: n
        }), t(window.VGSCollect);
      }, c.onerror = function() {
        u({
          type: s.SCRIPT_LOAD,
          status: "Failed",
          mainCDN: n
        }), n ? t(e(!1)) : o(v.SCRIPT_WAS_NOT_LOADED);
      });
    }
  });
  return r;
}, w = function(n, r) {
  window.VGSCollect.init = function(t) {
    return t === void 0 && (t = function() {
    }), window.VGSCollect.create(n, r, t);
  };
}, b = function() {
  d("dns-prefetch", p), d("dns-prefetch", m);
}, k = function() {
  d("preconnect", p), d("preconnect", m);
};
Promise.resolve().then(function() {
  typeof window < "u" && !window.VGSCollect && (b(), k());
});
var en = function(n) {
  n === void 0 && (n = _("config"));
  var r = n, t = r.vaultId, o = t === void 0 ? _("vaultId") : t, i = r.environment, a = i === void 0 ? l.environment : i, c = r.version, f = c === void 0 ? l.version : c;
  return f === "canary" && console.warn(v.CHANGE_VERSION), P({
    vaultId: o,
    environment: a,
    version: f
  }), new Promise(function(g, E) {
    if (typeof window > "u") {
      E(v.IS_UNDEFINED("window"));
      return;
    }
    window.VGSCollect && (w(o, a), g(window.VGSCollect)), j().then(function() {
      w(o, a), g(window.VGSCollect);
    }).catch(function(D) {
      E(D);
    });
  });
};
export {
  en as loadVGSCollect
};
